import { createRoutine } from 'redux-saga-routines';

export const fetchInventorySkuBySku = createRoutine(
  'FETCH_INVENTORY_SKU_BY_SKU'
);
